import React from "react";

interface AudioIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  color?: string;
}

const AudioIcon: React.FC<AudioIconProps> = ({
  width = "16",
  height = "17",
  color = "#666666",
  ...props
}) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4668 10.4748C13.1705 10.4748 12.9301 10.2268 12.9301 9.92128V8.19224C12.9301 5.38725 10.7167 3.10694 7.99892 3.10694C5.28109 3.10694 3.06776 5.38725 3.06776 8.19224V9.92128C3.06776 10.2268 2.82732 10.4748 2.53107 10.4748C2.23481 10.4748 1.99437 10.2268 1.99437 9.92128V8.19224C1.99437 4.77843 4.68858 2 7.99892 2C11.3093 2 14.0035 4.77843 14.0035 8.19224V9.92128C14.0035 10.2268 13.763 10.4748 13.4668 10.4748Z" fill={color}/>
<path d="M13.2693 14.9978H12.1014C11.8052 14.9978 11.5647 14.7498 11.5647 14.4443V9.92134C11.5647 9.61583 11.8052 9.36787 12.1014 9.36787H13.2693C14.7742 9.36787 16 10.6298 16 12.1839C16 13.7381 14.7763 15 13.2693 15V14.9978ZM12.6381 13.8908H13.2693C14.1817 13.8908 14.9266 13.1248 14.9266 12.1817C14.9266 11.2386 14.1838 10.4726 13.2693 10.4726H12.6381V13.8908Z" fill={color}/>
<path d="M3.89856 14.9976H2.73071C1.22581 14.9976 0 13.7357 0 12.1816C0 10.6274 1.22367 9.3655 2.73071 9.3655H3.89856C4.19481 9.3655 4.43525 9.61345 4.43525 9.91897V14.4419C4.43525 14.7475 4.19481 14.9954 3.89856 14.9954V14.9976ZM2.73071 10.4747C1.81833 10.4747 1.07339 11.2407 1.07339 12.1838C1.07339 13.1269 1.81618 13.8929 2.73071 13.8929H3.36186V10.4769H2.73071V10.4747Z" fill={color}/>
</svg>

  );
};

export default AudioIcon;

